import './Tags.scss';
import {SvgIcon} from '../svgIcon/SvgIcon';
interface ITag {
  number?: number;
  type: 'comment' | 'partner' | 'pro' | 'custom';
  text?: string;
  className?: string;
}
export const Tags = (props: ITag) => {
  const {number, type, text, className} = props;
  if (type === 'comment') {
    return (
      <div className="commentsTag">
        <SvgIcon icon="icon-comments" />
        {number}
      </div>
    );
  } else if (type === 'partner') {
    return (
      <div className={`partnersTag ${className}`}>
        <SvgIcon icon="icon-users" /> {number}
      </div>
    );
  } else if (type === 'pro') {
    return <div className="proTag">Pro</div>;
  } else if (text && type === 'custom') {
    return <div className={`proTag ${className}`}>{text}</div>;
  }
};
